<template>
    <div id="modals">
        <modalExportLut />
        <modalExportImage />
        <modalResetScene />
        <modalNewImage />
        <modalNewCandidate />
        <modalCreateCustomLutsFolder />
        <modalImportCustomLuts />
        <modalEditCustomLuts />
        <modalRenameCustomLutsFolder />
        <modalRenameCustomLut />
        <modalDeleteCustomCategory />
        <modalDeleteCustomLut />
        <NotAvailableInFree />
        <CompareView />
    </div>

</template>

<script>
import modalExportLut from '@/views/templates/modals/export-lut';
import modalExportImage from '@/views/templates/modals/export-image';
import modalResetScene from '@/views/templates/modals/reset-scene';
import modalNewImage from '@/views/templates/modals/new-image';
import modalNewCandidate from '@/views/templates/modals/new-candidate';
import modalCreateCustomLutsFolder from '@/views/templates/modals/create-custom-luts-folder';
import modalImportCustomLuts from '@/views/templates/modals/import-custom-luts';
import modalEditCustomLuts from '@/views/templates/modals/edit-custom-luts';
import modalRenameCustomLutsFolder from '@/views/templates/modals/rename-custom-luts-folder';
import modalRenameCustomLut from '@/views/templates/modals/rename-custom-lut';
import modalDeleteCustomCategory from '@/views/templates/modals/delete-custom-luts-folder';
import modalDeleteCustomLut from '@/views/templates/modals/delete-custom-lut';

import NotAvailableInFree from '@/views/templates/modals/not-available-in-free';
import CompareView from '@/views/templates/modals/compare-view';

export default {
    name: 'Modals',
    components: {
        NotAvailableInFree,
        modalExportLut,
        modalExportImage,
        modalResetScene,
        modalNewImage,
        modalNewCandidate,
        modalCreateCustomLutsFolder,
        modalImportCustomLuts,
        modalEditCustomLuts,
        modalRenameCustomLutsFolder,
        modalRenameCustomLut,
        modalDeleteCustomCategory,
        modalDeleteCustomLut,
        CompareView,
    }
};
</script>